import { render, staticRenderFns } from "./DashboardPolicyBliView.vue?vue&type=template&id=7911328b&"
import script from "./DashboardPolicyBliView.vue?vue&type=script&lang=ts&"
export * from "./DashboardPolicyBliView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports